// @ts-nocheck
import React, { useState } from "react";
import Cropper from "react-easy-crop";
import { blobUrlToFile, readFile } from "utils";
import { PaziaButton, PaziaSlider } from "components/atoms";
import { getCroppedImg, getRotatedImage } from "./canvasUtils";

const ORIENTATION_TO_ANGLE = {
  3: 180,
  6: 90,
  8: -90,
};

interface ImagePickerProps {
  defaultImage?: string;
  onConfirm?: (image: File, blobUrl: string) => void;
}
export const ImagePicker = ({ defaultImage, onConfirm }: ImagePickerProps) => {
  const [imageSrc, setImageSrc] = React.useState(defaultImage ?? null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels, rotation);

      const file = await blobUrlToFile(croppedImage, "example.png");
      if (onConfirm) {
        file.preview = croppedImage;
        onConfirm(file, croppedImage);
      }
      // setCroppedImage(croppedImage);
    } catch (e) {
      console.error(e);
    }
  };

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file);
      try {
        // apply rotation if needed
        const orientation = await getOrientation(file);
        const rotation = ORIENTATION_TO_ANGLE[orientation];
        if (rotation) {
          imageDataUrl = await getRotatedImage(imageDataUrl, rotation);
        }
      } catch (e) {
        console.warn("failed to detect the orientation");
      }

      setImageSrc(imageDataUrl);
    }
  };

  return (
    <>
      {imageSrc ? (
        <React.Fragment>
          <div className="relative h-full w-full">
            <Cropper
              image={imageSrc}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={3 / 4}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
          <div className="grid grid-cols-2 gap-x-8 px-8 py-2">
            <PaziaSlider label="Przybliżenie" min={1} max={3} step={0.1} onChange={(x) => setZoom(x)} />
            <PaziaSlider label="Rotacja" min={0} max={360} step={1} onChange={(x) => setRotation(x)} />

            <PaziaButton
              onClick={showCroppedImage}
              className="col-start-2"
              type="primary"
              btnType="button"
              title="Przytnij"
            />
          </div>
        </React.Fragment>
      ) : (
        <input type="file" onChange={onFileChange} accept="image/*" />
      )}
    </>
  );
};
